import { styled } from '@mui/material';

export const InboxContainer = styled('div')({
  backgroundColor: '#fff',
  borderLeft: '1px solid #D9D9D9',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',

  '& .communications-chat-box-textarea textarea': {
    color: '#000'
  },
  '& .communications-chat-box-textarea textarea::placeholder': {
    color: '#000',
    opacity: 1
  },
  '& .communications-chat-box-textarea .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #000'
  },

  '& .communications-chat-box button[type="submit"][disabled] svg': {
    color: '#A1AEBB'
  },

  '& .phone-number-select .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '& .phone-number-select .MuiInputBase-root': {
    backgroundColor: '#F9FAFB',
    minHeight: 45
  },
  '& .phone-number-select .MuiTypography-root': {
    color: '#000',
    fontWeight: 600,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center'
  },
  '& .phone-number-select .phone-number-icon': {
    width: 17,
    height: 17
  },
  '& .phone-number-select .MuiSelect-select': {
    minHeight: 'initial'
  },

  '& .communications-message-card': {
    paddingLeft: 0,
    paddingRight: 0,
    '&.campaign .MuiPaper-root': {
      border: '1px solid #D9D9D9',
      backgroundColor: '#FCFCFC',
      maxWidth: 283
    },
    '&.direct .message-card, &.incoming .message-card': {
      width: '100%'
    },
    '&.direct .MuiPaper-root': {
      backgroundColor: '#E8F2F6',
      border: 'none',
      color: '#2C3542'
    },
    '&.incoming .MuiPaper-root': {
      backgroundColor: '#EEE',
      border: 'none',
      color: '#2C3542'
    }
  },

  '& .card-label': {
    width: 'initial',
    '& p': {
      color: '#7D7D7D'
    }
  },
  '& .section-separator span': {
    color: '#7D7D7D'
  },

  '& .communications-call-card': {
    width: 253,
    minHeight: 60,
    border: '1px solid #D9D9D9',
    backgroundColor: '#FCFCFC',
    '& .MuiTypography-body2': {
      marginBottom: 2
    },
    '& .MuiListItemAvatar-root': {
      marginTop: 4
    }
  },

  '& .comms-preview-footer': {
    borderTop: 'none'
  },
  '& .email-card': {
    maxWidth: 294,
    marginLeft: 'auto'
  }
});

export const ContactHeader = styled('div')({
  padding: '16px 24px 6px',
  display: 'grid',
  gridTemplateColumns: '1fr auto'
});

export const FilterContainer = styled('div')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  right: 0,
  zIndex: 1000,
  paddingTop: 10,
  backgroundColor: '#fff'
});
